// extracted by mini-css-extract-plugin
module.exports = {"SlideNumber":"SlideNumber_SlideNumber__3DDX0"};